export default {
    name: "Tooltip",
    props: {
        text: {
            type: String,
            default: null
        },
        animation: {
            type: Boolean,
            default: false
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/tooltip/tooltip.js